import { X, Check, Clock, MessageCircle } from "lucide-react";
import "./PackageDetailsModal.css";

const PackageDetailsModal = ({
  isOpen,
  onClose,
  title,
  price,
  description,
  details = [],
  idealFor,
  delivery,
  whatsappLink
}) => {
  if (!isOpen) return null;

  return (
    <div className="package-modal-overlay" onClick={onClose}>

      <div
        className="package-modal"
        onClick={(e) => e.stopPropagation()}
      >

        {/* CLOSE BUTTON */}
        <button
          className="package-modal-close"
          onClick={onClose}
          aria-label="Close package details"
        >
          <X size={22} />
        </button>

        {/* HEADER */}
        <div className="package-modal-header">

          <span className="package-modal-label">
            PACKAGE DETAILS
          </span>

          <h2>{title}</h2>

          <div className="package-modal-price">
            {price === "Custom" ? (
              <>
                <strong>Custom</strong>
                <span>pricing</span>
              </>
            ) : (
              <>
                <small>STARTING</small>
                <strong>{price}</strong>
                <span>/project</span>
              </>
            )}
          </div>

          <p>{description}</p>

        </div>

        {/* IDEAL FOR */}
        {idealFor && (
          <div className="package-modal-section">
            <h3>Ideal For</h3>
            <p>{idealFor}</p>
          </div>
        )}

        {/* INCLUDED */}
        <div className="package-modal-section">

          <h3>What's Included</h3>

          <div className="package-modal-features">

            {details.map((detail, index) => (
              <div
                className="package-modal-feature"
                key={index}
              >
                <span className="package-modal-check">
                  <Check size={16} />
                </span>

                <span>{detail}</span>
              </div>
            ))}

          </div>

        </div>

        {/* DELIVERY */}
        {delivery && (
          <div className="package-modal-delivery">

            <Clock size={20} />

            <div>
              <span>Estimated Delivery</span>
              <strong>{delivery}</strong>
            </div>

          </div>
        )}

        {/* WHATSAPP CTA */}
        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="package-modal-whatsapp"
        >
          <MessageCircle size={21} />
          Get Started on WhatsApp
        </a>

      </div>

    </div>
  );
};

export default PackageDetailsModal;